module.exports = __webpack_public_path__ + "static/media/liveDrawBgBottom.8a5567d3.png";